export default __webpack_public_path__ + "static/media/227f547c58d13bce.7d0f0ace008b14334d189007b1f92bd9.svg";